define('v3/Common/Services/settingsService',['lodash'], function (_) {
	return {
		getAvailableGrades: function (showFullList) {
			var availableGrades = Settings.availableGrades;
			if (availableGrades.length === 0) return availableGrades;

			if (availableGrades[0].schoolType === 2 && !showFullList) {
				return _.map(_.groupBy(availableGrades, 'grade'), function (groupedGrade) {
					var currentGrade = groupedGrade[0].grade;
					var completeNamesArray = _.map(groupedGrade, 'gradeName');

					return {
						grade: currentGrade,
						gradeName: _.join(completeNamesArray, ' / ')
					};
				});
			}

			var prefix = availableGrades[0].schoolType === 2 ? '' : Strings.Grade + ' ';
			return _.map(availableGrades, function (grade) {
				return {
					grade: grade.grade,
					gradeName: prefix + grade.gradeName
				};
			});
		}
	};
});
